import RangeSlider from "./range-slider";

export default RangeSlider;
